export enum SkinColorsEnum {
    Default = 0,
    Dark = 1,
    Darker = 2,
    Whiter = 3,
    Brown = 4,
    Pale = 5,
    Paler = 6,
    NUM_OF_SKIN_COLORS
}